export { now, timer, timerFlush } from "./timer.js";
export { default as timeout } from "./timeout.js";
export { default as interval } from "./interval.js";


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-timer@1.0.10@d3-timer/src/index.js
// module id = 175
// module chunks = 0 1 2